import { render, staticRenderFns } from "./payCopy.vue?vue&type=template&id=67a3f8f0&"
import script from "./payCopy.vue?vue&type=script&lang=js&"
export * from "./payCopy.vue?vue&type=script&lang=js&"
import style0 from "./payCopy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports